import React, { useEffect } from 'react';
import AxiosPost from '../http/Axios';

const FollowUpEmailSender = () => {
  // Function to trigger the email sending process on the backend

  useEffect(() => {
    document.title = 'LeapFrog Lab Registration Admin Portal';
  }, []);

  const sendEmailsWithGuid = async () => {
    try {
      // Make a POST request to the Java backend to trigger the email sending process
      const response = await AxiosPost(
        process.env.REACT_APP_ADMIN_SERVICE +
          '/api/emails/send-follow-up-emails'
      );

      if (response.status === 200) {
        console.log('Follow-up emails sent successfully.');
      } else {
        console.error(
          'Failed to send follow-up emails:',
          response.status,
          response.data
        );
      }
    } catch (error) {
      console.error(
        'Error occurred while sending follow-up emails:',
        error.message
      );
    }
  };

  useEffect(() => {
    // Trigger the process when the component mounts
    sendEmailsWithGuid();
  }, []);

  return (
    <div>
      <h1>Sending Follow-Up Emails...</h1>
      <p>Check the console for status updates.</p>
    </div>
  );
};

export default FollowUpEmailSender;
